import { IxPricing } from './IxPricing.js';

window.customElements.define('ix-pricing', IxPricing);
